import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { memo } from 'react';
import styled, { css } from 'styled-components';
import { pxToRem } from 'utils/ui/units';
import { getSolidBackgroundShade } from 'utils/ui/colors';
import { borderValue, fillParent } from 'styles/mixins';

/* Components */

import Card from 'components/Card';
import ToolbarButton from 'components/ToolbarButton';
import StackedButton from 'components/StackedButton';
import { jsx as _jsx } from "react/jsx-runtime";
export var assetViewerBreakpoint = 'xs';
var mobileTitleBarHeight = pxToRem(57);
var getAssetViewerBreakpoint = function getAssetViewerBreakpoint(p) {
  return p.theme.globals.breakpoints[assetViewerBreakpoint];
};
export var Wrapper = styled(Card).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['isFullscreen', 'isFakeMobileFullscreen'].includes(prop);
  }
}).withConfig({
  displayName: "Layout__Wrapper",
  componentId: "sc-bj6bqq-0"
})(["display:flex;flex-direction:column;overflow:auto;overscroll-behavior:contain;height:100%;", ";@media (min-width:", "){flex-direction:row;}", ""], function (p) {
  return p.isFullscreen && css(["border-radius:0;"]);
}, getAssetViewerBreakpoint, function (p) {
  return p.isFakeMobileFullscreen && css(["flex-direction:column;@media (orientation:landscape){flex-direction:row;}"]);
});
export var FakeFullscreenButtonWrapper = styled.div.withConfig({
  displayName: "Layout__FakeFullscreenButtonWrapper",
  componentId: "sc-bj6bqq-1"
})(["display:flex;align-items:center;justify-content:center;border-bottom:", ";@media (orientation:landscape){border-bottom:none;border-right:", ";}@media print{display:none;}"], function (p) {
  return borderValue(p.theme);
}, function (p) {
  return borderValue(p.theme);
});
export var MobileFullscreenButtonWrapper = styled.div.withConfig({
  displayName: "Layout__MobileFullscreenButtonWrapper",
  componentId: "sc-bj6bqq-2"
})(["position:absolute;bottom:0;left:0;right:0;z-index:", ";text-align:center;pointer-events:none;& > *{pointer-events:all;}@media print{display:none;}"], function (p) {
  return p.theme.globals.z.raised;
});
export var MobileTitleBar = styled.header.withConfig({
  displayName: "Layout__MobileTitleBar",
  componentId: "sc-bj6bqq-3"
})(["position:relative;position:sticky;top:0;z-index:", ";height:", ";background-color:", ";@media print{display:none;}"], function (p) {
  return p.theme.globals.z.navbars;
}, mobileTitleBarHeight, function (p) {
  return p.theme.background;
});
export var StageWrapper = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['sticky', 'isFakeMobileFullscreen'].includes(prop);
  }
}).withConfig({
  displayName: "Layout__StageWrapper",
  componentId: "sc-bj6bqq-4"
})(["position:relative;flex:0 0 auto;background-color:", ";", " @media (min-width:", "){position:relative;top:0;z-index:initial;flex:1 1 auto;height:100%;max-height:none;}@media print{height:100%;max-height:none;}"], function (p) {
  return getSolidBackgroundShade(p.theme);
}, function (p) {
  return p.sticky && css(["@media (max-aspect-ratio:2/3){position:sticky;top:", ";z-index:", ";}flex-grow:1;", ""], mobileTitleBarHeight, function (p) {
    return p.theme.globals.z.raised;
  }, function (p) {
    return !p.isFakeMobileFullscreen && css(["height:100%;max-height:66.666vw;@media (orientation:landscape){max-height:33.333vw;}"]);
  });
}, getAssetViewerBreakpoint);
export var Stage = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'sticky';
  }
}).withConfig({
  displayName: "Layout__Stage",
  componentId: "sc-bj6bqq-5"
})(["", " overflow:auto;-webkit-overflow-scrolling:touch;border-bottom:", ";@media (min-width:", "){border-bottom:none;}&:focus{outline:none;}&.focus-visible{outline:3px solid ", ";outline-offset:3px;}"], function (p) {
  return p.sticky && fillParent;
}, function (p) {
  return borderValue(p.theme);
}, getAssetViewerBreakpoint, function (p) {
  return p.theme.links;
});
export var Sidebar = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isCollapsed';
  }
}).withConfig({
  displayName: "Layout__Sidebar",
  componentId: "sc-bj6bqq-6"
})(["position:relative;scroll-behavior:smooth;@media (min-width:", "){display:flex;flex-direction:column;flex:0 0 ", ";overflow:auto;border-left:", ";box-shadow:0 1rem 1.5rem 0.125rem rgba(0,0,0,0.15);}@media print{display:none;}"], getAssetViewerBreakpoint, function (p) {
  return p.isCollapsed ? 'auto' : pxToRem(360);
}, function (p) {
  return borderValue(p.theme);
});
export var SidebarButton = function SidebarButton(_ref) {
  var otherProps = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/_jsx(ToolbarButton, _objectSpread({
    tooltipPlacement: "left"
  }, otherProps));
};
var getGridSpacing = function getGridSpacing(p) {
  return p.theme.globals.spacing.xxs;
};
export var ActionGrid = styled.div.withConfig({
  displayName: "Layout__ActionGrid",
  componentId: "sc-bj6bqq-7"
})(["display:flex;flex-wrap:wrap;margin-left:-", ";margin-bottom:-", ";& > *{width:33.333%;padding-left:", ";padding-bottom:", ";}"], getGridSpacing, getGridSpacing, getGridSpacing, getGridSpacing);
export var ActionGridButton = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(StackedButton, _objectSpread({
      fullWidth: true
    }, props))
  });
});
ActionGridButton.displayName = 'ActionGridButton';